import apiClient from "../apiClient";
import { apiNodeBaseUrl } from "../../config";

export const getParameterStore = async (name) => {
  return apiClient
    .get(`${apiNodeBaseUrl}ssm/parameter/${name}`)
    .then((response) => {
      return response;
    });
};

export const putParameterStore = async (paramName, paramValue) => {
  return apiClient
    .put(`${apiNodeBaseUrl}ssm/parameter/${paramName}`, {
      value: paramValue,
    })
    .then((response) => {
      return response;
    });
};

export const deleteParameterStore = async (name) => {
  return apiClient
    .del(`${apiNodeBaseUrl}ssm/parameter/${name}`)
    .then((response) => {
      return response;
    });
};
